module.exports = __webpack_public_path__ + "static1/img/f65b39a2b64ff89b5ad7647cf309f32.397d1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/f65b39a2b64ff89b5ad7647cf309f32.png
// module id = GpDV
// module chunks = 1